// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"b4a95a1f","583":"f1b8b47a","710":"4d861cde"}[chunkId] + ".chunk.js";
};